import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  SelectEmpresas,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import { isRouteAllowed } from '../../../../services/permission/menus'
import ModalOcorrenciaEntrega from './ModalOcorrenciaEntrega'
import ModalImportOcorrenciaEntrega from './ModalImportOcorrenciaEntrega'
import useOcorrenciaEntrega, { LOAD_MESSAGE } from './OcorrenciaEntregaHook'

const IMPORTAR_OCORRENCIAS_PERMISSION = 149

function OcorrenciaEntrega({ dispatch, history }) {
  const { state, localDispatch } = useOcorrenciaEntrega()
  const canImportarOcorrencias = isRouteAllowed(IMPORTAR_OCORRENCIAS_PERMISSION)

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_DELIVERY_OCCURRENCES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getDeliveryOccurrences(state.selectedEmpresaID)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>2.20 - Cadastro de Ocorrências de Entrega</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid" style={{ marginBottom: 20 }}>
            <div className="p-col-12 p-md-3">
              <SelectEmpresas
                companyId={state.selectedEmpresaID}
                onChange={value => localDispatch.onEmpresaChange(value)}
              />
            </div>
            <div className="p-col-12 p-md-4" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Btn onClick={() => localDispatch.onBtnNovoEntrega(state.selectedEmpresaID)}>
                Novo
              </Btn>
              {canImportarOcorrencias && (
                <div style={{ marginLeft: 10 }}>
                  <Btn onClick={localDispatch.onBtnImportar}>Importar</Btn>
                </div>
              )}
              <div style={{ marginLeft: 10 }}>
                <Btn
                  onClick={() =>
                    localDispatch.onBtnExportar(
                      state.selectedEmpresaID,
                      state.selectedEmpresaName,
                      state.ocorrenciasEntrega,
                    )
                  }
                >
                  Exportar
                </Btn>
              </div>
            </div>
          </div>
          <DataTable
            selectionMode="single"
            onSelectionChange={e => localDispatch.onDeliveryRowClicked(e.value)}
            value={state.ocorrenciasEntrega}
            paginator={true}
            rows={10}
            emptyMessage={'Selecione a empresa desejada'}
            globalFilter={state.ocorrenciaEntregaFilter}
            header={
              <CustomDataTableHeader onChange={localDispatch.onChangeOcorrenciaEntregaFitler} />
            }
          >
            <Column field="sigla" header="Sigla" style={tableCellCentered()} />
            <Column field="company_code" header="Código Interno" style={tableCellCentered()} />
            <Column field="descricao" header="Descrição" />
            <Column
              field="assoc_guilty_client"
              header="Assoc. Cliente"
              style={tableCellCentered()}
              body={ocorrencia => (
                <CustomCheckbox disabled checked={ocorrencia.assoc_guilty_client} />
              )}
            />
            <Column
              field="actived"
              header="Ativo"
              style={tableCellCentered()}
              body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.actived} />}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <ModalOcorrenciaEntrega
        show={state.modalEntrega.show}
        onModalClose={localDispatch.onModalEntregaClose}
        onModalSave={localDispatch.onModalEntregaSave}
        data={state.modalEntrega.data}
      />
      <ModalImportOcorrenciaEntrega
        show={state.modalImportacao.show}
        onModalClose={localDispatch.onModalImportacaoClose}
        onImported={localDispatch.onOcorrenciasImportadas}
      />
    </div>
  )
}

export default connect()(withRouter(OcorrenciaEntrega))
